import { Publicity } from '@/modules/settings/publicity/types/Publicity.ts'
import { PublicityListResponse } from '@/modules/settings/publicity/services/apiValidations/listPublicityApiValidation.ts'

export const publicityPage1: { data: PublicityListResponse } = {
  data: {
    results: [
      {
        id: 1,
        name: 'Promoción de verano',
        image: 'promotions/promotion_6a3ac525d449c990619189.jpeg',
        showCount: 3,
        route: 'DONT_HAVE_WEPPA_PLUS',
        isActive: true,
        createdAt: '23/06/2026',
        updatedAt: '23/06/2026'
      },
      {
        id: 2,
        name: 'Descuento Weppa Plus',
        image: 'promotions/promotion_abc123.jpeg',
        showCount: 5,
        route: 'HAVE_WEPPA_PLUS',
        isActive: true,
        createdAt: '20/06/2026',
        updatedAt: '21/06/2026'
      },
      {
        id: 3,
        name: 'Oferta especial',
        image: null,
        showCount: 0,
        route: null,
        isActive: false,
        createdAt: '15/06/2026',
        updatedAt: '15/06/2026'
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 3,
      range: [1],
      count: 3,
      pages: 1,
      total: 3,
      limit: 20
    }
  }
}

export const publicityDetail: { data: Publicity } = {
  data: {
    id: 1,
    name: 'Promoción de verano',
    image: 'promotions/promotion_6a3ac525d449c990619189.jpeg',
    showCount: 3,
    route: 'DONT_HAVE_WEPPA_PLUS',
    isActive: true,
    createdAt: '23/06/2026',
    updatedAt: '23/06/2026'
  }
}
